import React from "react";
import { FaUser } from "react-icons/fa";

const testimonials = [
  {
    category: "Blockchain",
    title: "Reliable Blockchain Development Partner",
    desc: "Xeer Technology helped us build our smart contract and Web3 platform with great professionalism. Their team understood our requirements quickly and delivered a secure and scalable solution on time. Their blockchain expertise truly added value to our project.",
    name: "Client",
    role: "Blockchain Project",
    icon: FaUser,
  },
  {
    category: "CRM & ERP",
    title: "Excellent Custom Software Development",
    desc: "We approached Xeer Technology for a custom CRM and ERP system for our business operations. The system they developed streamlined our workflow, improved reporting, and helped our team manage operations efficiently across multiple departments.",
    name: "Client",
    role: "Business Operations",
    icon: FaUser,
  },
  {
    category: "Crypto",
    title: "Strong Technical Knowledge in Crypto & Web3",
    desc: "The Xeer team supported us in developing a crypto platform with token integration and exchange modules. Their understanding of blockchain architecture and security practices made the entire development process smooth and reliable.",
    name: "Client",
    role: "Crypto Platform",
    icon: FaUser,
  },
  {
    category: "AI Solutions",
    title: "Innovative AI Automation Solutions",
    desc: "Xeer Technology helped us implement AI-based automation for our customer support and internal operations. Their solutions significantly improved response times and reduced manual workload across our organization.",
    name: "Client",
    role: "AI Automation",
    icon: FaUser,
  },
  {
    category: "Web & Mobile",
    title: "Professional and Highly Supportive Team",
    desc: "Working with Xeer Technology on our website and mobile application was a great experience. Their team maintained clear communication, delivered quality work, and ensured our platform was optimized for performance and scalability.",
    name: "Client",
    role: "Web & Mobile",
    icon: FaUser,
  },
];

export default function Platforms() {
  return (
    <div className="services-style-one-area default-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What Our Clients Say</h4>
              <h2 className="title">Our clients trust us for</h2>
            </div>
          </div>
        </div>
      </div>

      <section className="platform-section">
        <div className="platforms-container">
          {/* FEATURED TESTIMONIAL */}
          <div className="platforms-card featured">
            <span className="platforms-badge purple">
              {testimonials[0].category}
            </span>

            <div className="platforms-stars">★★★★★</div>

            <h3 className="platforms-heading">{testimonials[0].title}</h3>

            <p className="platforms-text">{testimonials[0].desc}</p>

            <div className="platforms-profile">
              {/* <img src={testimonials[0].icon} sizes="30%" alt="" /> */}
              <div>
                <h4>{testimonials[0].name}</h4>
                <p>{testimonials[0].role}</p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE TESTIMONIALS */}
          <div className="platforms-right">
            {testimonials.slice(1).map((item, i) => (
              <div className="platforms-card small" key={i}>
                <span className="platforms-badge">{item.category}</span>

                <div className="platforms-stars">★★★★★</div>

                <h4 className="platforms-heading small">{item.title}</h4>

                <p className="platforms-text">{item.desc}</p>

                <div className="platforms-profile small-profile">
                  {/* <div src={item.icon} alt="" /> */}
                  <div>
                    <h4>{item.name}</h4>
                    <p>{item.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
